import { useState } from "react";
import { MessageSquare } from "lucide-react";
import { NotesLog } from "@/components/NotesLog";

// C2 — A NOTE ON A COMPONENT SHOWS RIGHT THERE (D95): the newest one on the row, every note one tap away, newest on
// top, never deleted (the one notes system).
export const ComponentNotes = ({ donorId, component, notes, canAdd, testid, big = false, onClosed }) => {
  const [open, setOpen] = useState(false);
  const n = notes?.count || 0;
  return (
    <div data-testid={testid} className={big ? "text-sm" : "text-xs"}>
      <button type="button" data-testid={`${testid}-toggle`} onClick={() => { if (open) onClosed?.(); setOpen((v) => !v); }}
        className={`inline-flex items-center gap-1.5 text-slate-600 hover:text-[#B01E28] ${big ? "min-h-12" : ""}`}>
        <MessageSquare className="w-3.5 h-3.5" />
        {n ? <span><b data-testid={`${testid}-count`}>{n} note{n === 1 ? "" : "s"}</b> — <span data-testid={`${testid}-last`} className="italic">“{notes.last?.body}”</span> · {notes.last?.by}</span>
          : <span data-testid={`${testid}-none`}>{canAdd ? "Add a note" : "No notes"}</span>}
      </button>
      {open && <div className="mt-2"><NotesLog recordType="component" recordId={`${donorId}:${component}`} canAdd={canAdd} /></div>}
    </div>
  );
};
